import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  MasterListFilterWrapper,
  MasterListFilterSearchBarWrapper,
  MasterListFilterSearchBar,
  MasterListFilterSearchBarIcon,
} from './MasterListFilter.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const MasterListFilter = ({ stringsData, handleMasterListSearchBarInputChange }) => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################

  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSearchBarInputChange = event => {
    const { value } = event.target;
    const searchQueryMinLength = 3;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleMasterListSearchBarInputChange(value);
      }, 300);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      handleMasterListSearchBarInputChange(value, true);
  };

  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <MasterListFilterWrapper>
      <MasterListFilterSearchBarWrapper>
        <MasterListFilterSearchBarIcon />
        <MasterListFilterSearchBar
          placeholder={stringsData.masterListHeader.masterListFilterSearchBarPlaceholder}
          value={searchQuery}
          onChange={event => handleSearchBarInputChange(event)}
          data-testid="masterListSearch"
        />
      </MasterListFilterSearchBarWrapper>
    </MasterListFilterWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

MasterListFilter.propTypes = {
  stringsData: PropTypes.shape({
    masterListHeader: PropTypes.shape({
      masterListFilterSearchBarPlaceholder: PropTypes.string,
    }),
  }).isRequired,
  handleMasterListSearchBarInputChange: PropTypes.func.isRequired,
  masterListQueryStrings: PropTypes.shape({}).isRequired,
};

MasterListFilter.defaultProps = {};

export default MasterListFilter;
